import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '../api';

export const useSystemConfig = () => {
  return useQuery({
    queryKey: ['settings', 'system'],
    queryFn: () => settingsApi.getSystemConfig(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useApiKeyStatus = () => {
  return useQuery({
    queryKey: ['settings', 'api-keys'],
    queryFn: () => settingsApi.getApiKeyStatus(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
